<template>
  <div class="home">
    <innerHeader v-if="!isMobile"></innerHeader>
    <AppHeader v-if="isMobile" />
    <ResponsiveContainer>
      <div class="main">
        <!--cloumnId控制contentList  Tab的active -->
        <contentList
          @tabChagnge="tabChagnge"
          :tabList="tabList"
          :leftTab="1"
          :cloumnId="cloumnId"
          v-if="!isMobile"
        >
          <div slot="main_content">
            <div class="content_top" v-if="list.length">
              <div class="content_con">
                <div
                  class="content_item"
                  v-for="(item, index) in list"
                  :key="index"
                >
                  <div
                    class="content_item_img"
                    v-if="item.coverImg && item.coverImg != ''"
                  >
                    <img v-lazy="item.coverImg" />
                  </div>
                  <div class="content_item_img" v-else>
                    <img src="../../assets/img/jzsb2.png" />
                  </div>
                  <div class="content_item_title">
                    <p class="title">{{ item.details.title }}</p>
                    <p class="desc">{{ item.details.digest }}</p>

                    <div class="content_item_d">
                      <p class="date">{{ item.details.publishTime }}</p>
                      <p class="detail" @click="toDetail(item.details.id)">
                        {{ $t('viewDetails') }}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="content_top" v-else>
              <el-empty :description="$t('noData')"></el-empty>
            </div>
          </div>
        </contentList>
        <AppcontentList
          @tabChagnge="tabChagnge"
          :tabList="tabList"
          :leftTab="1"
          :cloumnId="cloumnId"
          v-if="isMobile"
        >
          <div slot="main_content">
            <div class="app_content_top">
              <div
                class="content_item"
                v-for="(item, index) in list"
                :key="index"
              >
                <div class="content_item_img">
                  <img v-lazy="item.coverImg" />
                </div>
                <div class="content_item_title">
                  <p class="title">{{ item.title }}</p>
                  <!-- <p class="desc">{{ item.desc }}</p> -->
                  <div class="content_item_d">
                    <p class="date">{{ item.details.publishTime }}</p>
                    <p class="detail" @click="toDetail(item.details.id)">
                      {{ $t('viewDetails') }}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div></AppcontentList
        >
        <paginations
          :current-page.sync="page.current"
          @current-change="currentChange"
          :page-size="page.size"
          :total="page.total"
        ></paginations>
      </div>
    </ResponsiveContainer>
    <Footer v-if="!isMobile" />
    <innerAppFooter v-else />
  </div>
</template>

<script>
import innerHeader from '@/components/innerHeader.vue';
import AppHeader from '@/components/AppHeader';
import Footer from '@/components/Footer.vue';
import innerAppFooter from '@/components/innerAppFooter';
import ResponsiveContainer from '@/components/ResponsiveContainer';
import contentList from '@/components/contentList';
import AppcontentList from '@/components/AppcontentList';
import paginations from '@/components/Pagination.vue';
import responsiveMixin from '@/mixins/responsiveMixin';
import { newsTab } from '@/const';
import { fetchConentList } from '@/assets/api';
export default {
  name: 'News',
  mixins: [responsiveMixin],
  components: {
    innerHeader,
    AppHeader,
    innerAppFooter,
    Footer,
    ResponsiveContainer,
    contentList,
    AppcontentList,
    paginations,
  },
  data() {
    return {
      currentIndex: 0,
      page: { current: 1, size: 10, total: 0 },
      tabList: newsTab,
      cloumnId: null,
      list: [],
    };
  },
  mounted() {
    if (this.$route.query && this.$route.query.cloumnId) {
      this.cloumnId = this.$route.query.cloumnId;
    }
    this.getList();
  },
  methods: {
    tabChagnge(column, cloumnId) {
      this.cloumnId = cloumnId;
      this.$router.push({ path: column.accessPath });
      this.getList();
    },
    currentChange(e) {
      this.page.current = e;
      this.getList();
    },
    getList() {
      const data = {
        columnIds: this.cloumnId,
        size: this.page.size,
        current: this.page.current,
      };
      fetchConentList(data).then((res) => {
        this.list = res.records;
        this.page.total = res.total;
      });
    },
    toDetail(id) {
      this.$router.push({
        path: `/newsDetail?id=${id}&cloumnId=${this.cloumnId}`,
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.main {
  .content_top {
    padding: 40px 0;

    .content_con {
      display: flex;
      flex-wrap: wrap;
      .content_item {
        flex: 0 0 calc((100% - 40px) / 3);
        text-align: left;
        margin: 0 20px 20px 0;
        overflow: hidden;
        background: #fff;
        border-bottom: 6px solid #fff;
        &:nth-child(3n) {
          /* 去除第3n个的margin-right */
          margin-right: 0;
        }
        &:hover {
          box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
          border-bottom: 6px solid;
          border-image: linear-gradient(
              90deg,
              rgba(170, 229, 239, 1),
              rgba(177, 187, 255, 1)
            )
            6 6;
          .content_item_title {
            .content_item_d {
              .detail {
                display: block;
              }
            }
          }
        }
        .content_item_img {
          img {
            width: 100%;
            height: 350px;
            object-fit: cover;
          }
        }
        .content_item_title {
          padding: 1rem 1.25rem;
          .title {
            font-size: 1.125rem;
            color: #333;
            display: -webkit-box; /* 旧版 Flex 布局 */
            -webkit-line-clamp: 2; /* 限制行数 */
            -webkit-box-orient: vertical; /* 垂直排列 */
            overflow: hidden; /* 隐藏溢出 */
            text-overflow: ellipsis;
          }
          .desc {
            font-size: 0.875rem;
            color: #6b6d7a;
            display: -webkit-box; /* 旧版 Flex 布局 */
            -webkit-line-clamp: 2; /* 限制行数 */
            -webkit-box-orient: vertical; /* 垂直排列 */
            overflow: hidden; /* 隐藏溢出 */
            text-overflow: ellipsis;
          }
          .content_item_d {
            margin-top: 1.25rem;
            display: flex;
            justify-content: space-between;
            .date {
              font-size: 0.875rem;
              color: #c2c4ce;
            }
            .detail {
              text-decoration: underline;
              cursor: pointer;
              font-size: 0.875rem;
              color: #424451;
              display: none;
            }
          }
        }
      }
    }
  }
  .app_content_top {
    width: 100%;
    box-sizing: border-box;
    background: #fff;
    margin: 2rem 0;
    min-height: 42.9vh;
    .content_item {
      display: flex;
      justify-content: space-between;
      margin-bottom: 1rem;
      overflow: hidden;
      &:hover {
        box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
      }
      .content_item_img {
        width: 34.8%;
        height: 8.75rem;
        img {
          width: 100%;
          height: auto;
          object-fit: cover;
        }
      }
      .content_item_title {
        flex: 1;
        padding: 1rem;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        .title {
          text-align: left;
          font-size: 1.1667rem;
          color: #333;
          display: -webkit-box; /* 旧版 Flex 布局 */
          -webkit-line-clamp: 3; /* 限制行数 */
          -webkit-box-orient: vertical; /* 垂直排列 */
          overflow: hidden; /* 隐藏溢出 */
          text-overflow: ellipsis;
        }
        .desc {
          font-size: 0.875rem;
          color: #6b6d7a;
          display: -webkit-box; /* 旧版 Flex 布局 */
          -webkit-line-clamp: 2; /* 限制行数 */
          -webkit-box-orient: vertical; /* 垂直排列 */
          overflow: hidden; /* 隐藏溢出 */
          text-overflow: ellipsis;
        }
        .content_item_d {
          margin-top: 1.25rem;
          display: flex;
          justify-content: space-between;
          .date {
            font-size: 0.8333rem;
            color: #c2c4ce;
          }
          .detail {
            padding: 0.1667rem 0.5rem;
            cursor: pointer;
            font-size: 0.8333rem;
            color: #fff;
            background: linear-gradient(270deg, #6b6d7a 0%, #a9a9a9 100%);
            border-radius: 20px 20px 20px 20px;
          }
        }
      }
    }
  }
}
</style>
